import { useScrollReveal } from '@/hooks/useScrollReveal';

const indexes = [
  {
    title: '触手漫画 · 奇幻冒险精选',
    count: '48 部',
    desc: '深海、遗迹、异世界，触手与冒险的完美融合',
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20adventure%20scene%20with%20organic%20flowing%20forms%20in%20deep%20ocean%2C%20crimson%20and%20onyx%20tones%2C%20atmospheric%20underwater%20ruins%2C%20cinematic%20composition%2C%20no%20text&width=800&height=500&seq=index-01&orientation=landscape',
  },
  {
    title: '触手漫画 · 科幻异种合集',
    count: '35 部',
    desc: '未来世界、外星生物、科技与触手的碰撞',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20alien%20landscape%20with%20organic%20scifi%20forms%2C%20dark%20metallic%20and%20crimson%20color%20palette%2C%20atmospheric%20cyberpunk%20scene%2C%20cinematic%20wide%20shot%2C%20no%20text&width=800&height=500&seq=index-02&orientation=landscape',
  },
  {
    title: '触手漫画 · 都市传说系列',
    count: '29 部',
    desc: '隐藏在城市阴影中的超自然触手物语',
    image: 'https://readdy.ai/api/search-image?query=Dark%20urban%20alley%20with%20mysterious%20supernatural%20atmosphere%2C%20crimson%20and%20charcoal%20noir%20style%2C%20dramatic%20shadows%2C%20cinematic%20composition%2C%20no%20text&width=800&height=500&seq=index-03&orientation=landscape',
  },
  {
    title: '触手漫画 · 热血战斗名录',
    count: '42 部',
    desc: '燃到炸裂的触手战斗场景，每一页都是视觉盛宴',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20combat%20scene%20with%20dark%20energy%20flowing%20forms%2C%20crimson%20explosions%2C%20dramatic%20lighting%2C%20intense%20atmosphere%2C%20cinematic%20wide%20shot%2C%20no%20text&width=800&height=500&seq=index-04&orientation=landscape',
  },
  {
    title: '触手漫画 · 完结经典回顾',
    count: '56 部',
    desc: '已完结的触手漫画经典作品，一口气读到爽',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20library%20with%20dark%20aesthetic%20and%20mysterious%20atmosphere%2C%20crimson%20accents%2C%20classic%20composition%2C%20warm%20dramatic%20lighting%2C%20no%20text&width=800&height=500&seq=index-05&orientation=landscape',
  },
  {
    title: '触手漫画 · 新锐连载推荐',
    count: '23 部',
    desc: '最新上线的触手题材漫画，发现宝藏新作',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20mysterious%20emerging%20forms%20in%20dark%20atmosphere%2C%20crimson%20and%20onyx%20gradient%2C%20modern%20aesthetic%2C%20cinematic%20composition%2C%20no%20text&width=800&height=500&seq=index-06&orientation=landscape',
  },
  {
    title: '触手漫画 · 编辑部精选',
    count: '18 部',
    desc: '编辑团队精心挑选的触手漫画口碑佳作',
    image: 'https://readdy.ai/api/search-image?query=Curated%20elegant%20dark%20aesthetic%20scene%20with%20flowing%20organic%20shapes%2C%20crimson%20and%20gold%20accents%2C%20premium%20atmosphere%2C%20cinematic%20composition%2C%20no%20text&width=800&height=500&seq=index-07&orientation=landscape',
  },
];

export default function IndexSection() {
  const { ref: titleRef, visible: titleVisible } = useScrollReveal(0.12);

  return (
    <section id="index" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div ref={titleRef} className={`text-center mb-12 ${titleVisible ? 'animate-fade-in-up' : 'animate-initial-hidden'}`}>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/60 border border-accent-200/50 mb-4">
            <i className="ri-folder-3-line text-accent-600 text-xs w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-medium text-accent-700 whitespace-nowrap">分类导航 · 快速找漫</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            专题合集
          </h2>
          <div className="w-16 h-0.5 bg-primary-500 mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-600">
            触手漫画分类专题，快速找到你喜欢的类型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {indexes.map((item, idx) => (
            <IndexCard key={idx} item={item} idx={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}

function IndexCard({ item, idx }: { item: typeof indexes[0]; idx: number }) {
  const { ref, visible } = useScrollReveal(0.06);

  return (
    <a
      ref={ref}
      href="#cards"
      className={`group block bg-background-50 rounded-lg border border-background-200/60 hover:border-primary-300 transition-all overflow-hidden cursor-pointer ${
        visible ? `animate-fade-in-up animate-stagger-${idx + 1}` : 'animate-initial-hidden'
      } ${idx === 0 ? 'sm:col-span-2 lg:col-span-2' : ''}`}
    >
      <div className="relative h-36 md:h-44 overflow-hidden">
        <img
          src={item.image}
          alt={item.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
        <div className="absolute bottom-3 left-4 right-4">
          <h3 className="text-sm md:text-base font-semibold text-white line-clamp-1">{item.title}</h3>
          <span className="text-xs text-white/70">{item.count}</span>
        </div>
      </div>
      <div className="p-4">
        <p className="text-xs md:text-sm text-foreground-600 line-clamp-2">{item.desc}</p>
      </div>
    </a>
  );
}